// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const FilterIcon = (props?: any) => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M3 10h9.18a3 3 0 005.63 0H21a1 1 0 000-2h-3.2a3 3 0 00-5.63 0H3a1 1 0 000 2zm12-2a1 1 0 11-1 1 1 1 0 011-1zm6 6h-9.2a3 3 0 00-5.63 0H3a1 1 0 000 2h3.17a3 3 0 005.63 0H21a1 1 0 000-2zM9 16a1 1 0 111-1 1 1 0 01-1 1z"/></svg>'} />;

(FilterIcon as any).displayName = 'FilterIcon';

export default FilterIcon;
